/**
 * TUT-406 — o armazenamento do navegador, por uma porta que nunca derruba o app.
 *
 * `localStorage`/`sessionStorage` LANÇAM em navegação privada (Safari),
 * com o armazenamento cheio, ou quando o navegador bloqueia dados do site —
 * e várias telas chamavam `setItem` direto num handler ou num efeito: a
 * exceção subia e a tela quebrava por causa de uma PREFERÊNCIA (o tema, a
 * coluna escondida, o grupo recolhido da barra lateral). Aqui, falhar é só
 * não lembrar: a leitura devolve `null` e a gravação vira nada.
 */
type Area = "local" | "sessao";

function area(qual: Area): Storage | null {
  try {
    if (typeof window === "undefined") return null;
    return qual === "local" ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
}

export function lerLocal(chave: string, qual: Area = "local"): string | null {
  try {
    return area(qual)?.getItem(chave) ?? null;
  } catch {
    return null;
  }
}

export function gravarLocal(chave: string, valor: string, qual: Area = "local"): void {
  try {
    area(qual)?.setItem(chave, valor);
  } catch {
    // Sem espaço ou sem permissão: a preferência só não é lembrada.
  }
}

export function apagarLocal(chave: string, qual: Area = "local"): void {
  try {
    area(qual)?.removeItem(chave);
  } catch {
    // Idem: nada a lembrar, nada a apagar.
  }
}
